import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { edcUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useDeleteEdc = (edcId: number | string | undefined) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (id: number | string | undefined) => {
      await axios.delete(edcUrls.mutateEdc(id).apiUrl);
    },
    onSuccess: async () => {
      toast.success(`Deleting the EDC with the Id ${edcId} was successful`);
      navigate(edcUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
